// extracted by mini-css-extract-plugin
export default {"draftPublishButton":"DraftPublishButton_draftPublishButton__hDvBf"};